import { cloneDeep, isEmpty } from 'lodash'

import { Services, empty } from '@sigma-frontend-libs/commons'

import { globalErrorHandler, request, sendingsOutputFilter } from '@/utils'

import render from './render'

export default {
  name: 'SaveTemplateButton',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      payload: cloneDeep(empty.templates.create),

      loading: false,
      showDialog: false
    }
  },

  computed: {
    validation() {
      if (isEmpty(this.payload.title)) {
        return false
      }

      return true
    },

    disabled() {
      if (this.loading) {
        return true
      }
      if (isEmpty(this.payload.payload?.sender) || isEmpty(this.payload.payload?.text)) {
        return true
      }

      return false
    }
  },

  watch: {
    value: {
      handler(value) {
        if (value) {
          this.setPayload()
        }
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    setPayload() {
      const { type, payload, recipient, fallbacks } = this.value || {}
      this.payload = {
        ...cloneDeep(empty.templates.create),
        OwnerId: this.account.id,
        type,
        payload,
        recipient,
        fallbacks
      }
    },

    async create() {
      try {
        this.loading = true
        const response = await request.create(Services.templates, { body: sendingsOutputFilter(this.payload) }, { scopes: [ 'full' ] })
        if (response) {
          this.showDialog = false
        }
      } catch (error) {
        globalErrorHandler(error)
      } finally {
        this.loading = false
      }
    }
  },

  render
}
